(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-trendyol-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gs-product-reviews')) {
    customElements.define('gs-product-reviews', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.tablist = this.querySelector('[data-review-tabs]');
        this.tabs = Array.from(this.querySelectorAll('[data-review-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-review-panel]'));
        if (!this.tablist || this.tabs.length !== this.panels.length || !this.tabs.length) return;

        this.tablist.setAttribute('role', 'tablist');
        this.tabs.forEach((tab, index) => {
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', this.panels[index].id);
          this.panels[index].setAttribute('role', 'tabpanel');
          this.panels[index].tabIndex = 0;
          tab.addEventListener('click', event => {
            event.preventDefault();
            this.select(index);
          }, { signal });
          tab.addEventListener('keydown', event => {
            let next = index;
            if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
            else if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = this.tabs.length - 1;
            else if (event.key === ' ') {
              event.preventDefault();
              this.select(index);
              return;
            } else return;
            event.preventDefault();
            this.select(next);
            this.tabs[next].focus();
          }, { signal });
        });

        this.addEventListener('shopify:block:select', event => {
          const index = this.panels.findIndex(panel => panel.contains(event.target));
          if (index !== -1) this.select(index);
        }, { signal });
        const linkedPanel = this.panels.findIndex(panel => '#' + panel.id === location.hash);
        this.select(linkedPanel === -1 ? 0 : linkedPanel);
      }

      select(index) {
        this.tabs.forEach((tab, tabIndex) => {
          const selected = tabIndex === index;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          this.panels[tabIndex].hidden = !selected;
        });
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
